export const HIGHLIGHTS_FOOTER_LENGTH = 106;

export const COMMENTS_FOOTER_LENGTH = 10;

interface FooterOffsetProps {
  maxAbsolutePosition: number;
  percentagePosition: number;
  showLollipopFooter: boolean | undefined;
}

interface FooterOffsetHook {
  footerOffset: number;
  footerWidth: number;
}

export const useLollipopFooterOffset = ({
  maxAbsolutePosition,
  percentagePosition,
  showLollipopFooter = false,
}: FooterOffsetProps): FooterOffsetHook => {
  const footerWidth = showLollipopFooter ? HIGHLIGHTS_FOOTER_LENGTH : COMMENTS_FOOTER_LENGTH;
  const defaultOffset = 0;
  const halfFooterWidth = footerWidth / 2;
  // lollipop position is an percentage, thats why is needed to convert it to the pixels
  const lollipopPositionOnTimeline = (maxAbsolutePosition * percentagePosition) / 100;

  // if old comment
  if (footerWidth === COMMENTS_FOOTER_LENGTH) {
    return { footerOffset: defaultOffset, footerWidth };
  }
  // left timeline border offset
  if (lollipopPositionOnTimeline - halfFooterWidth < 0) {
    const off = halfFooterWidth - lollipopPositionOnTimeline;

    return { footerOffset: off, footerWidth };
  }
  // right timeline border offset
  if (lollipopPositionOnTimeline + halfFooterWidth > maxAbsolutePosition) {
    const off = maxAbsolutePosition - lollipopPositionOnTimeline - halfFooterWidth;

    return { footerOffset: off, footerWidth };
  }

  return { footerOffset: defaultOffset, footerWidth };
};
